import { Component, OnInit } from '@angular/core';
import {HttpClient } from '@angular/common/http';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {environment as env} from '../../../environments/environment';
import {Category} from '../../models/category';
import {ProductsService} from '../../services/products.service'; 
import {LanguageService} from '../../services/language.service'; 
import { OrderonlineServiceService } from '../../services/orderonline-service.service';


@Component({
  selector: 'app-subcats',
  templateUrl: './subcats.component.html',
  styleUrls: ['./subcats.component.css']
})
export class SubcatsComponent implements OnInit {
  cats:Category[] = [];
  subcatsAr:any[] = [];
  prdlist:any[] = [];
  tmpAr = [];
  isEmpty:boolean = false;
  error:string;
  imgurl:string; 
  catslug:string;
  catName:string;
  catNameAr:string;
  isLoading:boolean;
  showLang:string;
  orderOnlineBanner = [];

  constructor(private http:HttpClient,  
    private router:Router,     
    private route:ActivatedRoute,
    private orderOnlieService:OrderonlineServiceService, 
    private langObj:LanguageService,
    private srvprod:ProductsService,) {
      this.langObj.langStr.subscribe((data)=>{
        this.showLang = data;
      });
    }

  ngOnInit(): void {
    this.imgurl =  env.imgurl;
    this.isLoading = true;
    this.showLang = localStorage.getItem("showLang");
     if(this.showLang == null && this.showLang == undefined){
      this.showLang = 'en';
     }
    
    this.orderOnlieService.orderOnlineBanner('Order Now Banner').subscribe((data:any)=>{
      this.orderOnlineBanner = data.data[0];
    });

    this.srvprod.getallcats().subscribe(data => {
      if(data['data'].length <= 0){this.isEmpty = true;}
      this.cats = data['data'];
    },error=> {this.error  = error.message;});


    this.route.params.subscribe((params:Params)=>{
      if(params['catslug']){
        this.catslug = params['catslug'];
        this.http.get(env.apiurl+'get-subcats-by-slug/'+this.catslug).subscribe(data=>{
          this.isLoading = false;
          this.catName = data['maincat'];
          this.catNameAr = data['maincat_ar'];
          this.subcatsAr = data['data'];
        }); 
      }
    });
  }
}